export default __webpack_public_path__ + "static/media/0.65782b87.jpg";